import { attributes } from '../../core/ids-attributes';

export type IdsDropdownOption = {
  id?: string,
  label: string,
  value: string,
  icon?: string,
  hex?: string,
  color?: string,
  tooltip?: string,
  groupLabel?: boolean,
  description?: boolean,
  // Stores the unmodified label text for tooltip display during typeahead operations
  originalLabel?: string,
  // ids-multiselect shared
  isCheckbox?: boolean,
  selected?: boolean,
  index?: number,
  // Allow additional properties for multi-column data
  [key: string]: any
};

export type IdsDropdownOptions = Array<IdsDropdownOption>;

export type IdsDropdownColumn = {
  id: string,
  name?: string,
  width?: string,
  minWidth?: string,
  maxWidth?: string
};

export const IdsDropdownCommonAttributes = [
  attributes.ALLOW_BLANK,
  attributes.CLEARABLE,
  attributes.CLEARABLE_TEXT,
  attributes.DESCRIPTION,
  attributes.DROPDOWN_ICON,
  attributes.DISABLED,
  attributes.GROUP,
  attributes.GROUP_LABEL,
  attributes.INPUT_AUTO_SIZE,
  attributes.LABEL_WRAP,
  attributes.LIST,
  attributes.MAX_COLUMNS,
  attributes.MULTI_COLUMN,
  attributes.NO_MARGINS,
  attributes.PLACEHOLDER,
  attributes.READONLY,
  attributes.SHOW_LOADING_INDICATOR,
  attributes.SHOW_LIST_ITEM_ICON,
  attributes.SIZE,
  attributes.TYPEAHEAD,
  attributes.VALUE
];

// List of available color variants for this component
export const IdsDropdownColorVariants: string[] = [
  'alternate-formatter',
  'borderless',
  'in-cell',
  'module-nav'
];
